import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Compass, Calendar, MessageCircle, Map, User } from 'lucide-react';

const BottomNav = ({ user, onLoginClick }) => {
    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 lg:hidden z-50 pb-safe">
            <div className="flex justify-around items-center h-16">
                <NavLink 
                    to="/" 
                    className={({ isActive }) => `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-brand-primary' : 'text-gray-500 hover:text-gray-700'}`}
                >
                    <Home size={20} />
                    <span className="text-[10px] font-medium">Home</span>
                </NavLink>

                <NavLink 
                    to="/directory" 
                    className={({ isActive }) => `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-brand-primary' : 'text-gray-500 hover:text-gray-700'}`}
                >
                    <Compass size={20} />
                    <span className="text-[10px] font-medium">Directory</span>
                </NavLink>

                <NavLink 
                    to="/community" 
                    className={({ isActive }) => `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-brand-primary' : 'text-gray-500 hover:text-gray-700'}`}
                >
                    <MessageCircle size={20} />
                    <span className="text-[10px] font-medium">Community</span>
                </NavLink>

                <NavLink 
                    to="/events" 
                    className={({ isActive }) => `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-brand-primary' : 'text-gray-500 hover:text-gray-700'}`}
                >
                    <Calendar size={20} />
                    <span className="text-[10px] font-medium">Events</span>
                </NavLink>

                {user ? (
                    <NavLink 
                        to="/profile" 
                        className={({ isActive }) => `flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-brand-primary' : 'text-gray-500 hover:text-gray-700'}`}
                    >
                        <User size={20} />
                        <span className="text-[10px] font-medium">Profile</span>
                    </NavLink>
                ) : (
                    <button 
                        onClick={onLoginClick}
                        className="flex flex-col items-center justify-center w-full h-full space-y-1 text-gray-500 hover:text-gray-700"
                    >
                        <User size={20} />
                        <span className="text-[10px] font-medium">Log In</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default BottomNav;
